<template>
  <div>
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import { Line } from 'vue-chartjs';

export default {
  extends: Line,

  props: {
    labels: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
    dataLabel: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    datasets: {
      type: Array,
      default: () => [],
    },
  },

  mounted() {
    const colors = ['#378ADD', '#7F77DD', '#D85A30', '#2B9A66', '#BA7517', '#AFA9EC'];
    const chartDatasets = this.datasets.length
      ? this.datasets.map((dataset, index) => ({
          label: dataset.label || '',
          data: dataset.data || [],
          unit: dataset.unit || '',
          precision: dataset.precision,
          borderColor: colors[index % colors.length],
          backgroundColor: 'transparent',
          fill: false,
          lineTension: 0,
          pointRadius: 4,
          pointHoverRadius: 6,
        }))
      : [
          {
            label: this.dataLabel,
            data: this.data,

            borderColor: '#378ADD',
            backgroundColor: 'rgba(55,138,221,0.1)',

            fill: true,
            lineTension: 0, // smooth curve
            pointRadius: 4,
            pointHoverRadius: 6,
          },
        ];
    const chartUnit = chartDatasets.find((dataset) => dataset.unit)?.unit || '';
    const formatValue = (value, dataset) => {
      const precision = parseInt(dataset.precision, 10);
      const numericValue = Number(value);
      if (Number.isNaN(precision) || Number.isNaN(numericValue)) return value;
      return numericValue.toLocaleString(undefined, {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
      }) + (dataset.unit ? ` ${dataset.unit}` : '');
    };

    this.renderChart(
      {
        labels: this.labels,
        datasets: chartDatasets,
      },
      {
        responsive: true,
        maintainAspectRatio: false,

        title: {
          display: Boolean(this.title),
          text: this.title,
          fontSize: 11,
          fontStyle: 'normal',
          padding: 8,
        },

        legend: {
          display: chartDatasets.length > 1,
          position: 'top',
        },

        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              const dataset = data.datasets[tooltipItem.datasetIndex];
              const value = formatValue(tooltipItem.yLabel, dataset);
              if (data.datasets.length > 1) {
                return `${dataset.label}: ${value}`;
              }
              return `Total: ${value}`;
            },
          },
        },

        scales: {
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              scaleLabel: {
                display: Boolean(chartUnit),
                labelString: chartUnit,
              },
            },
          ],
        },
      },
    );
  },
};
</script>

<style scoped>
div {
  height: 100%;
}
</style>
